<template>
  <div class="title--main" v-html="title"></div>
</template>

<script>
export default {
  name: "TiTulo",
  props: ["title"],
};
</script>

<style>
.title--main {
  width: 100%;
  margin: 48px 0px 15px 0px;
  color: #3b3c3e;
  font-family: "MaisFuturo-Thin";
  font-size: 31px;
  text-align: left;
  letter-spacing: -1.4px;
  line-height: 38px;
}
</style>
